export const LOCAL_STORAGE_LOCALE_KEY = 'Locale';
export const USER_COUNTRY_LOCALE_KEY = 'userCountry';

export const LOCALE = {
  EN: 'en',
  AR: 'ar',
  AR_SA: 'ar-SA'
};
